"use client";

import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";
import { disconnectSocialAccount } from "../../client/manager/cross-posting";
import { invalidateCrossPosting } from "./invalidation";
import type { SocialPlatform } from "../../models/ayrshare";

interface DisconnectSocialAccountInput {
  comedianId: string;
  platform: SocialPlatform;
}

/**
 * Unlink a platform for a comedian. Invalidates scope: "profile" on success
 * (D-05 — linked accounts live inside the profile response).
 *
 * Pessimistic per D-06. Returns raw useMutation result per D-08.
 */
export function useDisconnectSocialAccount(): UseMutationResult<
  { success: true },
  Error,
  DisconnectSocialAccountInput,
  unknown
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: DisconnectSocialAccountInput) =>
      disconnectSocialAccount(input.comedianId, input.platform),
    onSuccess: (_data, variables) => {
      void invalidateCrossPosting(queryClient, {
        comedianId: variables.comedianId,
        scope: "profile",
      });
    },
  });
}
